import { useController, useFormContext } from 'react-hook-form'
import { TextField, MenuItem } from '@mui/material'
import { getDefaultValue } from '@/utils/rules'
import { PropertyFieldProps } from './PropertyField'

type PropertySelectProps = PropertyFieldProps

export default function PropertySelect({
  propertyId,
  property,
  required,
  shrinkLabel,
  variant,
}: PropertySelectProps) {
  const { field } = useController({
    name: propertyId,
    rules: { required },
    defaultValue: getDefaultValue(property),
    shouldUnregister: true,
  })
  const { formState } = useFormContext()
  const { errors } = formState
  const { display } = property

  const options: {
    label: string
    value: string
  }[] = property.options

  return (
    <TextField
      required={required}
      error={!!errors[propertyId]}
      label={display?.label || 'MISSING LABEL'}
      select
      helperText={display.description}
      variant={variant}
      slotProps={{
        inputLabel: {
          shrink: shrinkLabel,
        },
      }}
      {...field}
    >
      {options?.length > 0 ? (
        options.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No options available.</MenuItem>
      )}
    </TextField>
  )
}
